import { list as listRes } from "../api/plan";
import { CURRENT_USER_PLAN_LIST } from "../store/mutation-types";
import store from "../store/index";

/**
 * 获取plan列表
 * @returns {Promise<*>}
 */
export async function list() {
  const { data } = await listRes();
  // 保存到vuex中
  store.commit(CURRENT_USER_PLAN_LIST, data);
  return data;
}
